import { AppState, useAppSelector } from '@redux/store';

export const useTeamsList = () =>
  useAppSelector(({ teams }: AppState) => teams.list);
